import { render, staticRenderFns } from "./BusquedaPedidos.vue?vue&type=template&id=c0c63e2a"
import script from "./BusquedaPedidos.vue?vue&type=script&lang=js"
export * from "./BusquedaPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports